/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompleteOrderExaminationApiModel } from './completeOrderExaminationApiModel';
import { CompleteOrderAssessedItemApiModel } from './completeOrderAssessedItemApiModel';


export interface CompleteOrderApiModel { 
    assessedItems: Array<CompleteOrderAssessedItemApiModel>;
    examinations: Array<CompleteOrderExaminationApiModel>;
    issueDate: string;
}

